import React from 'react';
import { useGameStore } from './store/gameStore';
import { useWebSocket } from './hooks/useWebSocket';
import { LandingScreen } from './components/screens/LandingScreen';
import { SettingsScreen } from './components/screens/SettingsScreen';
import { LobbyScreen } from './components/screens/LobbyScreen';
import { RoleSelectionScreen } from './components/screens/RoleSelectionScreen';
import { CharacterSelectionScreen } from './components/screens/CharacterSelectionScreen';
import { GameplayScreen } from './components/screens/GameplayScreen';
import { DayEndScreen } from './components/screens/DayEndScreen';
import { GameEndScreen } from './components/screens/GameEndScreen';
import './theme/theme.css';

function App() {
  const { phase, isConnected, error, setError } = useGameStore();
  const { send } = useWebSocket();

  // Clear error after 5 seconds
  React.useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [error, setError]);

  const renderScreen = () => {
    switch (phase) {
      case 'landing':
        return <LandingScreen send={send} />;
      case 'settings':
        return <SettingsScreen send={send} />;
      case 'lobby':
        return <LobbyScreen send={send} />;
      case 'role_selection':
        return <RoleSelectionScreen send={send} />;
      case 'character_selection':
        return <CharacterSelectionScreen send={send} />;
      case 'gameplay':
        return <GameplayScreen send={send} />;
      case 'day_end':
        return <DayEndScreen send={send} />;
      case 'game_end':
        return <GameEndScreen send={send} />;
      default:
        return <LandingScreen send={send} />;
    }
  };

  return (
    <div className="app">
      {/* Connection indicator */}
      <div style={{
        position: 'fixed',
        top: 8,
        right: 8,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        color: isConnected ? 'var(--ltc-success)' : 'var(--ltc-danger)',
        fontFamily: 'var(--ltc-font-body)',
      }}>
        <span style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: isConnected ? 'var(--ltc-success)' : 'var(--ltc-danger)',
        }} />
        {isConnected ? 'Connected' : 'Disconnected'}
      </div>

      {/* Error toast */}
      {error && (
        <div style={{
          position: 'fixed',
          top: 16,
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'var(--ltc-danger)',
          color: 'white',
          padding: '12px 24px',
          border: 'var(--ltc-border)',
          boxShadow: 'var(--ltc-shadow)',
          fontFamily: 'var(--ltc-font-body)',
          zIndex: 1000,
        }}>
          {error}
        </div>
      )}

      {renderScreen()}
    </div>
  );
}

export default App;
